import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PolicyType } from "../types";
import { DndContext, closestCenter } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { SortableTableRow } from "./SortableTableRow";

interface PolicyTypeTableProps {
  policyTypes: PolicyType[];
  onEdit: (policyType: PolicyType) => void;
  onDelete: (id: string) => void;
  onDragEnd: (event: any) => void;
}

export const PolicyTypeTable = ({ 
  policyTypes, 
  onEdit, 
  onDelete,
  onDragEnd 
}: PolicyTypeTableProps) => {
  return (
    <DndContext
      collisionDetection={closestCenter}
      onDragEnd={onDragEnd}
    >
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[40px]"></TableHead>
            <TableHead>Policy Type</TableHead>
            <TableHead>Description</TableHead>
            <TableHead className="w-[100px]">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <SortableContext
            items={policyTypes.map(type => type.id)}
            strategy={verticalListSortingStrategy}
          >
            {policyTypes.map((type) => (
              <SortableTableRow
                key={type.id}
                id={type.id}
                type={type}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))}
          </SortableContext>
        </TableBody>
      </Table>
    </DndContext>
  );
};